import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase/config';

type AuthMethod = 'email_password' | 'google';

export function logLoginAttempt(method: AuthMethod) {
  logEvent(analytics, 'login_attempt', { auth_method: method });
}

export function logLoginSuccess(method: AuthMethod) {
  logEvent(analytics, 'login_success', { auth_method: method });
}

export function logLoginFailure(method: AuthMethod, errorReason: string) {
  logEvent(analytics, 'login_failure', {
    auth_method: method,
    error_reason: errorReason,
  });
}

export function logSignUpAttempt(method: AuthMethod) {
  logEvent(analytics, 'sign_up_attempt', { method });
}

export function logSignUpSuccess(method: AuthMethod) {
  logEvent(analytics, 'sign_up', { method });
}

export function logSignUpFailure(method: AuthMethod, errorReason: string) {
  logEvent(analytics, 'sign_up_failure', { method, error_reason: errorReason });
}
